import React, { useMemo } from "react";
import { useMessageSource } from "react-message-source";
import RadioButtonContainer from "../../../../../ui/layout/page/forms-container/form-item-container/radio-button-container/input-container";
import OnboardingRadioButton from "../../../../shared/components/formik/radiobutton";

interface BillingTypeOptionProps {
  hasDecentralizedInvoicing: boolean;
}

export const BillingTypeOption = ({
  hasDecentralizedInvoicing,
}: BillingTypeOptionProps): React.JSX.Element => {
  const { getMessage } = useMessageSource();

  const decentralizedInvoicingOption = useMemo(
    () => (
      <OnboardingRadioButton
        wrap={false}
        id={"decentralizedInvoicingAddress"}
        name={"decentralizedInvoicingAddress"}
        values={[
          {
            id: "COMPANY_ADDRESS",
            value: "COMPANY_ADDRESS",
            label: getMessage(
              `BillingType.DecentralizedAddress.COMPANY_ADDRESS.label`,
            ),
          },
          {
            id: "PRIVATE_ADDRESS",
            value: "PRIVATE_ADDRESS",
            label: getMessage(
              `BillingType.DecentralizedAddress.PRIVATE_ADDRESS.label`,
            ),
          },
        ]}
      />
    ),
    [getMessage],
  );

  return (
    <div className="scd-section-helper-md">
      <RadioButtonContainer>
        <OnboardingRadioButton
          wrap={false}
          title={getMessage("BillingType.title")}
          id={"hasDecentralizedInvoicing"}
          name={"hasDecentralizedInvoicing"}
          values={[
            {
              id: "Centralised",
              value: false,
              label: getMessage("BillingType.Centralized.label"),
            },
            {
              id: "Decentralised",
              value: true,
              label: getMessage("BillingType.Decentralized.label"),
            },
          ]}
        />

        {hasDecentralizedInvoicing && decentralizedInvoicingOption}
      </RadioButtonContainer>
    </div>
  );
};
